import { Calendar, ChartLineData, DocumentTasks, Microphone, RecentlyViewed, SettingsAdjust, Template, Undo, UserSettings } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * AI-скрайб в вебе (ТЗ, раздел 5; Приложение D «Веб — врач» и «Веб — клиника»). Матрица 2.2 и ПОРТ-01:
 * записи приёмов видят врач-автор (свои) и главврач (все + журнал правок); собственник — только количество приёмов;
 * шаблоны: главврач — изменение, врач и собственник — чтение (врач — свои личные шаблоны).
 */
export const sections = [
  /* «Мой день» — главный экран врача (DESIGN.md 1.6): в меню только у роли врача, главврачу доступен по ссылке. */
  defineSection({
    id: 'scribe.today',
    area: 'clinic',
    path: 'today',
    roles: ['DOCTOR', 'MED_DIRECTOR'],
    navRoles: ['DOCTOR'],
    icon: Calendar,
    titleKey: 'scribe:myDay.title',
    navGroup: 'work',
    order: 5,
    load: () => import('./screens/MyDayPage'),
  }),
  defineSection({
    id: 'scribe.encounters',
    area: 'clinic',
    path: 'scribe/*',
    roles: ['DOCTOR', 'MED_DIRECTOR'],
    icon: Microphone,
    titleKey: 'scribe:nav.encounters',
    navGroup: 'work',
    order: 10,
    load: () => import('./screens/ScribeRoutes'),
  }),
  defineSection({
    id: 'scribe.summary',
    area: 'clinic',
    path: 'scribe/summary',
    roles: ['OWNER'],
    icon: ChartLineData,
    titleKey: 'scribeAdmin:nav.summary',
    namespaces: ['scribe'],
    navGroup: 'manage',
    order: 15,
    tabGroup: 'reports',
    load: () => import('./admin/OwnerSummaryPage'),
  }),
  defineSection({
    id: 'scribe.templates',
    area: 'clinic',
    path: 'scribe/templates/*',
    roles: ['MED_DIRECTOR', 'DOCTOR', 'OWNER'],
    icon: Template,
    titleKey: 'scribeAdmin:nav.templates',
    namespaces: ['scribe'],
    navGroup: 'work',
    order: 20,
    load: () => import('./admin/TemplatesRoutes'),
  }),
  defineSection({
    id: 'scribe.editLog',
    area: 'clinic',
    path: 'scribe/edit-log',
    roles: ['MED_DIRECTOR'],
    icon: RecentlyViewed,
    titleKey: 'scribeAdmin:nav.editLog',
    namespaces: ['scribe'],
    navGroup: 'manage',
    order: 16,
    tabGroup: 'reports',
    load: () => import('./admin/EditLogPage'),
  }),
  /* CS-04: отзывы согласия пациентов — главврач решает судьбу созданных аудио и расшифровок. */
  defineSection({
    id: 'scribe.revocations',
    area: 'clinic',
    path: 'scribe/consent-revocations',
    roles: ['MED_DIRECTOR'],
    icon: Undo,
    titleKey: 'scribeAdmin:nav.revocations',
    namespaces: ['scribe'],
    navGroup: 'manage',
    order: 23,
    tabGroup: 'clinic',
    load: () => import('./admin/ConsentRevocationsPage'),
  }),
  defineSection({
    id: 'scribe.settings',
    area: 'clinic',
    path: 'scribe/settings',
    roles: ['MED_DIRECTOR', 'OWNER'],
    icon: SettingsAdjust,
    titleKey: 'scribeAdmin:nav.settings',
    namespaces: ['scribe'],
    navGroup: 'manage',
    order: 24,
    tabGroup: 'clinic',
    load: () => import('./admin/ClinicSettingsPage'),
  }),
  defineSection({
    id: 'scribe.myStats',
    area: 'clinic',
    path: 'scribe/me/stats',
    roles: ['DOCTOR'],
    icon: DocumentTasks,
    titleKey: 'scribeDoctor:nav.stats',
    namespaces: ['scribe'],
    navGroup: 'me',
    order: 11,
    // Статистика скрайба — часть «Моей статистики» (/analytics/me); адрес оставлен для старых ссылок.
    nav: false,
    load: () => import('@/app/pages/MyStatsRedirect'),
  }),
  /* «Настройки» врача: подразделы «Скрайб», «Уведомления», «Вход и безопасность» (docs/redesign-round2-2026-09-27.md №2). */
  defineSection({
    id: 'scribe.mySettings',
    area: 'clinic',
    path: 'settings/*',
    roles: ['DOCTOR'],
    icon: UserSettings,
    titleKey: 'scribeDoctor:settingsPage.title',
    namespaces: ['scribe', 'portal', 'notifications', 'account'],
    navGroup: 'me',
    order: 20,
    load: () => import('./doctor/SettingsPage'),
  }),
  defineSection({
    id: 'scribe.mySettingsLegacy',
    area: 'clinic',
    path: 'scribe/me/settings',
    roles: ['DOCTOR'],
    icon: UserSettings,
    titleKey: 'scribeDoctor:settingsPage.title',
    navGroup: 'me',
    order: 21,
    nav: false,
    load: () => import('./doctor/SettingsRedirect'),
  }),
];
